/**
 * Validador centralizado para nicknames
 * Reglas: mínimo 7, máximo 50 caracteres
 * Caracteres permitidos: letras, números, puntos (.), guiones (-), guiones bajos (_)
 */

const NICKNAME_MIN_LENGTH = 7;
const NICKNAME_MAX_LENGTH = 50;
const NICKNAME_REGEX = /^[a-zA-Z0-9._\-]+$/;

export interface NicknameValidationResult {
  valido: boolean;
  error?: string;
}

/**
 * Valida un nickname según las reglas del sistema
 * @param nickname - El nickname a validar
 * @returns Objeto con propiedades valido y error (si aplica)
 */
export const validarNickname = (nickname: string): NicknameValidationResult => {
  const nicknameStr = String(nickname).trim();

  if (!nicknameStr) {
    return { valido: false, error: "Nombre de usuario vacío" };
  }

  if (nicknameStr.length < NICKNAME_MIN_LENGTH) {
    return {
      valido: false,
      error: `Nombre de usuario debe tener mínimo ${NICKNAME_MIN_LENGTH} caracteres`,
    };
  }

  if (nicknameStr.length > NICKNAME_MAX_LENGTH) {
    return {
      valido: false,
      error: `Nombre de usuario no puede exceder ${NICKNAME_MAX_LENGTH} caracteres`,
    };
  }

  if (!NICKNAME_REGEX.test(nicknameStr)) {
    return {
      valido: false,
      error: "Nombre de usuario solo puede contener: letras, números, puntos (.), guiones (-) y guiones bajos (_)",
    };
  }

  return { valido: true };
};

/**
 * Obtiene las reglas de validación de nickname en formato texto
 */
export const getNicknameRules = (): string => {
  return `Entre ${NICKNAME_MIN_LENGTH} y ${NICKNAME_MAX_LENGTH} caracteres`;
};

/**
 * Obtiene el maxLength para inputs
 */
export const getNicknameMaxLength = (): number => {
  return NICKNAME_MAX_LENGTH;
};
